import { render } from "./touchspinSteps.vue?vue&type=template&id=b1fd676c"
import script from "./touchspinSteps.vue?vue&type=script&lang=js"
export * from "./touchspinSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__